angular.module 'zc.projects'

.directive 'zcNewsletterParametersList', (ProjectNewsletterParameter) ->
  restrict: "E"
  scope:
    project: "="
  templateUrl: "/templates/projects/directives/projects/newsletter_parameters_list.html"

  link: (scope, element, attrs) ->
    scope.newsletter_parameters = []
    ProjectNewsletterParameter.all scope.project.id
    .then (res) ->
      scope.newsletter_parameters = res




// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/newsletter_parameters_list.directive.coffee